import { render, staticRenderFns } from "./DeleteClientModal.vue?vue&type=template&id=720eef1a&scoped=true&class=fill-height&"
import script from "./DeleteClientModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteClientModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteClientModal.vue?vue&type=style&index=0&id=720eef1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720eef1a",
  null
  
)

export default component.exports